import {
  type GetWorkspaceEntitlementsQuery,
  useGetWorkspaceEntitlementsQuery,
} from "src/graphql";

type WorkspaceEntitlements =
  GetWorkspaceEntitlementsQuery["getWorkspaceEntitlements"];

export type Entitlements = Omit<
  WorkspaceEntitlements["entitlements"],
  "__typename"
>;

type Overage = Omit<WorkspaceEntitlements["overage"], "__typename">;

export type UseEntitlementsResult = {
  isLoading: boolean;
  data: {
    overage: Overage;
    entitlements: Entitlements;
  };
};

const DEFAULT_ENTITLEMENTS: Entitlements = {
  audiences: false,
  externalStorage: false,
  matchbooster: false,
  idr: false,
  pidr: false,
  events: false,
  analytics: false,
  analyticsPreLaunch: false,
  campaigns: false,
  journeys: false,
  cep: false,
  decisionEngine: false,
  syncUsageReporting: false,
  predictiveTraits: false,
  dataAgents: false,
  adStudio: false,
  lifecycleStudio: false,
  realtimeAudiences: false,
  auditLogs: false,
  sso: false,
};

const DEFAULT_OVERAGE: Overage = {
  destinationOverage: false,
  premiumOverage: false,
  overage: false,
  firstOverageDate: null,
  overageLockout: false,
  destinationOverageText:
    "This workspace has exceeded the number of destinations allowed on its current plan.",
};

export const useEntitlements = (
  enabled: boolean,
  suspense = false,
): UseEntitlementsResult => {
  const { data, isLoading } = useGetWorkspaceEntitlementsQuery(undefined, {
    enabled,
    suspense,
    staleTime: 60_000,
  });

  const result = data?.getWorkspaceEntitlements;

  return {
    isLoading,
    data: {
      overage: result?.overage ?? DEFAULT_OVERAGE,
      entitlements: result?.entitlements ?? DEFAULT_ENTITLEMENTS,
    },
  };
};
